import React, { Component } from 'react';
import { Doughnut } from 'react-chartjs-2';
import PropTypes from 'prop-types';
import { attach } from '@mgc/map-client-shared/lib/ReduxStore';
import { mapSelectors } from '@mgc/map-client-shared/lib/ReduxTools';
import selectors from '../selectors';
import utils from '../utils';
import strings from '../strings';

const _CHART_SIZE = 175;

class Balance extends Component {
    static propTypes = {
        offerBalance: PropTypes.number.isRequired,
        cartTotal: PropTypes.number.isRequired,
        hasOverspent: PropTypes.bool.isRequired,
        tempCartTotal: PropTypes.number.isRequired,
        hasTempCartOverspent: PropTypes.bool.isRequired,
        editCart: PropTypes.bool.isRequired,
    };
    constructor(props) {
        super(props);
        this.state = {
            selectedCartTotal: 0,
            hasOverspentForSelected: false,            
        };
    }

    static mapState = (state) =>
        mapSelectors(state, {
            offerBalance: selectors.offer.getSelectedBalance,
            cartTotal: selectors.cart.getTotal,
            hasOverspent: selectors.cart.hasOverspent,
            tempCartTotal: selectors.cart.getTempCartTotal,
            hasTempCartOverspent: selectors.cart.hasTempCartOverspent,
        });
    
        componentDidUpdate() {            
            if(this.props.editCart){
                if(this.state.selectedCartTotal !== this.props.cartTotal || this.state.hasOverspentForSelected !== this.props.hasOverspent){
                    this.setState({ selectedCartTotal: this.props.cartTotal, hasOverspentForSelected: this.props.hasOverspent });
                }
            }else{
                if(this.state.selectedCartTotal !== this.props.tempCartTotal || this.state.hasOverspentForSelected !== this.props.hasTempCartOverspent){
                    this.setState({ selectedCartTotal: this.props.tempCartTotal, hasOverspentForSelected: this.props.hasTempCartOverspent });
                }
                
            }
          }

    _getRemainingBalance() {
        return this.props.offerBalance - this.state.selectedCartTotal - (this.props.editCart ? 0 : this.props.cartTotal);
    }

    _getErrorChartData() {
        return {
            datasets: [
                {
                    data: [this.props.offerBalance],
                    backgroundColor: ['#c00'],
                    hoverBackgroundColor: ['#c00'],
                },
            ],
        };
    }

    _getValidCartData() {
        return {
            datasets: [
                {
                    data: [this.state.selectedCartTotal, this._getRemainingBalance()],
                    backgroundColor: ['#4b8edb', '#e1eef5'],
                    hoverBackgroundColor: ['#5cb85c', '#3d434b'],
                },
            ],
            labels: [strings.creditsUtilized, strings.availableCredits],
        };
    }

    _getChartData() {
        if (this.state.hasOverspentForSelected) {
            return this._getErrorChartData();
        }
        return this._getValidCartData();
    }

    _getTotalClasses() {
        if (this.state.hasOverspentForSelected) {
            return 'text-danger';
        }
        return 'text-info';
    }

    _getBalanceClasses() {
        const base = 'text-muted text-sm text-uppercase text-dark';
        if (this.state.hasOverspentForSelected) {
            return base + ' text-danger';
        }
        return base;
    }

    render() {
        return (
            <div className="p-a-md balance-indicator">
                <h2 className="text-md text-uppercase text-dark">
                    {strings.credits}
                </h2>
                <div className="chart-doughnut-container m-b">
                    <div className="chart-doughnut-middle text-sm is-fadedin">
                        <div className="display-2" style={{ marginBottom: -5 }}>
                            <b className={this._getTotalClasses()}>
                                {utils.formatPrice(this.state.selectedCartTotal)}
                            </b>
                        </div>
                        <div className={this._getBalanceClasses()}>
                            {utils.formatPrice(this._getRemainingBalance())}{' '}
                            {strings.available}
                        </div>
                    </div>
                    <Doughnut
                        id="chart-doughnut"
                        className="chart-doughnut"
                        width={_CHART_SIZE}
                        height={_CHART_SIZE}
                        options={{
                            responsive: false,
                            cutoutPercentage: 85,
                            legend: {
                                display: false,
                            },
                            animationSteps: 60,
                            animateScale: false,
                            showTooltips: false,
                        }}
                        data={this._getChartData()}
                    />
                </div>
            </div>
        );
    }
}

export default attach(Balance);



// WEBPACK FOOTER //
// ./app/components/Balance.jsx